/** A link the other phone can open. A public address works on any network. */
export async function lanPlayUrl(photonAppId: string): Promise<string> {
  try {
    const res = await fetch(new URL('__net', document.baseURI));
    if (!res.ok) return '';
    const data = (await res.json()) as { hosts?: string[]; publicUrl?: string };
    const q = new URLSearchParams({ tutorial: '0' });
    if (photonAppId) q.set('photon', photonAppId);
    const published = (data.publicUrl || '').trim();
    if (published) {
      const url = new URL(published);
      q.forEach((value, key) => url.searchParams.set(key, value));
      return url.toString();
    }
    const host = data.hosts?.[0];
    if (!host) return '';
    const port = location.port ? `:${location.port}` : '';
    return `${location.protocol}//${host}${port}${location.pathname}?${q}`;
  } catch {
    return '';
  }
}
